import React from 'react';
import T from 'prop-types';
import { Wizard, WizardPage } from '@piggybank/form';
import { Declaration, Products, ReviewDetails } from './pages';
import { useSelector } from 'react-redux';
import { get, head } from 'lodash-es';
import { hasEquityProduct } from 'srcAlias/client/segments/eligibility/checkResponse';

export const Customer = ({ nextSegment, config }) => {
  const [segmentName] = config;

  const customerData = useSelector((state) =>
    get(state, 'appDataReview.responseData.data', {})
  );

  const products = useSelector((state) => state.eligibility.responseData.data);
  const productDetails = get(products, 'productDetails', []);
  const eligibleProducts =
    Array.isArray(productDetails) && productDetails.length > 0
      ? productDetails.filter(
          (product) => product.eligibilityIndicator === true
        )
      : [];
  const accountID = head(
    eligibleProducts.map((accountObj) => accountObj.accountNumberDisplay)
  );

  const accountList = useSelector(
    (state) => state.accountList.responseData.data
  );
  const accounts = get(accountList, 'investmentAccounts', []);
  const hasEquitiesProduct = accounts ? hasEquityProduct(accounts) : false;

  const productType = useSelector((state) =>
    get(state, 'productSelection.productCode')
  );
  return (
    <Wizard onSubmit={nextSegment} name={segmentName}>
      <WizardPage name="reviewDetails">
        <ReviewDetails
          segmentName={segmentName}
          pageName="reviewDetails"
          customerData={customerData}
        />
      </WizardPage>
      <WizardPage name="products">
        <Products
          segmentName={segmentName}
          pageName="products"
          productID={accountID}
          eligibleProducts={eligibleProducts}
          hasEquitiesProduct={hasEquitiesProduct}
        />
      </WizardPage>
      <WizardPage name="declaration">
        <Declaration
          segmentName={segmentName}
          pageName="declaration"
          customerData={customerData}
          productType={productType}
        />
      </WizardPage>
    </Wizard>
  );
};

Customer.propTypes = {
  nextSegment: T.func,
  config: T.arrayOf(T.oneOfType([T.string, T.object])),
};

export default Customer;
